var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"46610cdd9cb17b9e5ffd415c1dacf0a969a4c010"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["docupet-app-login@docupet"]={id:"46610cdd9cb17b9e5ffd415c1dacf0a969a4c010"};
      